/* The way in, in ONAM's style: the landing moment (/home) and the console hub (/entry-hub).
   MAP's Orbit and Orbit2 keep all their logic (permissions, landing page, console state)
   and render these instead of the atom diagram. */

import React, { useState } from "react";
import OnamIntro, { introPending } from "./OnamIntro";
import { openFromCard } from "./portal";
import { Glyph, Loader64, reducedMotion } from "../mark";
import "../onam.css";
import "../onam-map.css";
import "../chrome/chrome.css";

export interface HubCard { title: string; desc: string; live: boolean; cta?: string; state?: string; onClick: () => void }

/** /home: shown for a moment while MAP works out where to send you. */
export function OnamLanding() {
  // the first time in a visit, the ONAM introduction builds here; the hub finishes it (OnamIntro.tsx)
  if (introPending()) return <div className="onam-app hub onam-frame"><OnamIntro mode="landing" /></div>;
  return (
    <div className="onam-app hub onam-frame">
      <div className="landing" role="status" aria-label="Loading">
        <div className="hub-mark"><Loader64 lap="1.6s" /></div>
        <span className="label">Getting things ready</span>
      </div>
    </div>
  );
}

/** /entry-hub: Discover, Engage and Measure, then the cards inside each console.
    The brand block on the left is exactly as tall as the cards: mark on top, name at the bottom. */
export function OnamHub({ console: con, cards, onBack }: { console: string | null; cards: HubCard[]; greeting?: string; onBack: () => void }) {
  // the introduction plays over the hub once per visit; the cards rise as it hands over (OnamIntro.tsx)
  const [intro, setIntro] = useState(introPending);
  const [revealed, setRevealed] = useState(!intro);
  const [wasIntro] = useState(intro);
  return (
    <div className="onam-app hub onam-frame">
      {intro ? <OnamIntro mode="hub" onReveal={() => setRevealed(true)} onDone={() => setIntro(false)} /> : null}
      {/* during the introduction the page waits hidden, then fades in already in place while the tiles glide to its
          mark (oi-in); the mark itself shows once they land (oi-flying). Without an introduction, the usual entrance. */}
      <main className={`view ${!revealed ? "oi-wait" : intro ? "oi-in oi-flying" : wasIntro && !con ? "" : reducedMotion() ? "" : "enter"}`} key={con || "home"}>
        <section className={`hubp ${con ? "console" : "home"}`}>
          <div className="hub-brand">
            <div className="hub-id">
              {/* two laps, then the mark rests: the hub is not waiting for anything (brand: motion only for what is live),
                  and a loop that never ends kept the page busy (optimisation pass, 17 Oct). The landing above keeps looping. */}
              <div className="hub-mark"><Loader64 lap="1.6s" laps={2} /></div>
              {con ? <h1 className="hub-word">{con}</h1> : <h1 className="sr-only">ONAM by Saptharushi</h1>}
            </div>
            {con ? <button className="hub-back" onClick={onBack}><Glyph n="arrow" /> Back to ONAM</button> : null}
          </div>
          <div className="hub-right"><div className="hub-cards">
            {cards.map((c, i) => (
              <button key={c.title} className={`hcard ${c.live ? "live" : "muted"}`} style={{ ["--i" as any]: i }}
                onClick={(e) => (con && c.live ? openFromCard(e.currentTarget, c.onClick) : c.onClick())}>
                <span className="hc-top"><span className="t-dim">{String(i + 1).padStart(2, "0")}</span>{c.live ? <span className="st confirm">Live</span> : <span className="st idle">{c.state || "Coming soon"}</span>}</span>
                <span className="hc-t">{c.title}</span><span className="hc-d">{c.desc}</span>
                <span className="hc-go">{c.live ? <><span>{c.cta}</span><span className="arrowc"><Glyph n="arrow" /></span></> : <span />}</span>
              </button>))}
          </div></div>
        </section>
      </main>
    </div>
  );
}
